module.exports = __webpack_public_path__ + "static/media/the-porpoise.249aa115.jpg";